export function imageChannels(image) { return image.channels ?? 4; }
export function imageStride(image) { return image.stride ?? image.width * imageChannels(image); }
export function pixelOffset(image, x, y) { return y * imageStride(image) + x * imageChannels(image); }
export function assertPixelImage(image) {
    if (!Number.isInteger(image.width) || image.width < 1)
        throw new RangeError('invalid image width');
    if (!Number.isInteger(image.height) || image.height < 1)
        throw new RangeError('invalid image height');
    const channels = imageChannels(image);
    if (channels !== 3 && channels !== 4)
        throw new RangeError('image channels must be 3 or 4');
    const stride = imageStride(image);
    if (stride < image.width * channels)
        throw new RangeError('image stride is too small');
    const required = stride * (image.height - 1) + image.width * channels;
    if (image.data.length < required)
        throw new RangeError('image data is too small');
}
export function cropPixelImage(source, rect) {
    assertPixelImage(source);
    if (!Number.isInteger(rect.x) || !Number.isInteger(rect.y) || !Number.isInteger(rect.width) || !Number.isInteger(rect.height)
        || rect.x < 0 || rect.y < 0 || rect.width < 0 || rect.height < 0
        || rect.x + rect.width > source.width || rect.y + rect.height > source.height)
        throw new RangeError('crop is outside image');
    const channels = imageChannels(source);
    const stride = rect.width * channels;
    const out = new Uint8ClampedArray(stride * rect.height);
    const sourceStride = imageStride(source);
    for (let y = 0; y < rect.height; y++) {
        const start = (rect.y + y) * sourceStride + rect.x * channels;
        out.set(source.data.subarray(start, start + stride), y * stride);
    }
    return { width: rect.width, height: rect.height, data: out, channels, stride };
}
//# sourceMappingURL=image.js.map